export default (days = [], offset = 1, delimiter = '／') => {
  const dayMapping = ['一', '二', '三', '四', '五', '六', '日'];
  return days.sort().map((day) => dayMapping[day - offset]).join(delimiter);
};
